<script lang="ts">
  import { goto } from "@roxi/routify";

  // services
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";

  // components
  import PendingRequests from "@retailer/svelte/LimitedOrderingProductRequests/Pending/PendingRequests.svelte";
  import HistoryTable from "@retailer/svelte/LimitedOrderingProductRequests/HistoryTable.svelte";
  import DiscoveryPanel from "@shared/svelte/DiscoveryPanel/DiscoveryPanel.svelte";

  // stores
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  const { trackClick } = EventTracking;

  export let discoveryPanelConfig: any[] = [];

  let activeTab: string = "pending";
  const tabs: { [key: string]: string } = {
    pending: "Pending",
    history: "History",
  };

  const handleTabClick = tabId => {
    activeTab = tabId;

    const targetObject =
      activeTab === "pending" ? "product_approvals_pending_tab" : "product_approvals_history_tab";

    trackClick(targetObject);

    $goto(`/product_approvals`);
  };

  const hasHistoryRollout = stagedRolloutCheck("disco__approval_queue_history");
</script>

<style>
  .product-approvals-banner {
    max-width: 912px;
  }
</style>

<div class="fizz-styles" style="height: 100%;">
  <div class="background-grayLight" style="height: 100%;">
    <div class="fizz-container background-white">
      <div
        class={$LayoutStore.isMobile ? "fizz-inset-square-16" : "fizz-inset-square-32"}
        class:fizz-border-bottom={!hasHistoryRollout}
      >
        <div class="fizz-flex-row-responsive fizz-space-between">
          <div>
            <h1 class="fizz-flex-row-8 fizz-heading-3 fizz-align-self-center fizz-stack-8">
              <span>Product Requests</span>
              <span class="fizz-badge-small fizz-surface-inverse">New</span>
            </h1>
            <div class="fizz-text-medium">
              Manage product requests for all locations in one place
            </div>
          </div>
          {#if stagedRolloutCheck("group_director_banner_ads")}
            <div class="product-approvals-banner">
              <DiscoveryPanel
                bind:configuration={discoveryPanelConfig}
                pageName={"product_approvals"}
                mobileMode={$LayoutStore.isMobile}
              />
            </div>
          {/if}
        </div>
      </div>

      {#if hasHistoryRollout}
        <ul class="fizz-tab-list fizz-full-width">
          {#each Object.entries(tabs) as [tabKey, tabName]}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <li
              class:fizz-is-active={activeTab === tabKey}
              data-testid={`${tabKey}-tab`}
              on:click={() => handleTabClick(tabKey)}
            >
              {tabName}
            </li>
          {/each}
        </ul>
        {#if activeTab === "pending"}
          <PendingRequests />
        {:else if activeTab === "history"}
          <HistoryTable />
        {/if}
      {:else}
        <PendingRequests />
      {/if}
    </div>
  </div>
</div>
